import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  ICreateDesengateBody,
  ICreateDesengateResponse,
  ICreateEngateBody,
  ICreateEngateResponse,
  IGetCarretasNaoEngatadasInfoByIdOrPlacaOrAgendamentoParams,
  IGetCarretasNaoEngatadasInfoByIdOrPlacaOrAgendamentoResponse,
  IGetEngateDesengateInfoByIdResponse,
  IGetEngatesOrDesengatesParams,
  IGetEngatesOrDesengatesResponse,
  IGetReceiptDesengateByIdResponse,
  IGetReceiptEngateByIdResponse
} from './engateDesengate.model';

@Injectable({
  providedIn: 'root'
})
export class EngateDesengateService {
  constructor(private http: HttpClient) {}

  public CreateEngate(
    body: ICreateEngateBody,
    guid: string
  ): Observable<ICreateEngateResponse> {
    const headers = new HttpHeaders({
      IdempotencyKey: guid
    });
    const url = `${environment.baseURL}EngateDesengate/CreateEngate`;

    return this.http.post<any>(url, body, { headers: headers });
  }

  public CreateDesengate(
    body: ICreateDesengateBody,
    guid: string
  ): Observable<ICreateDesengateResponse> {
    const headers = new HttpHeaders({
      IdempotencyKey: guid
    });
    const url = `${environment.baseURL}EngateDesengate/CreateDesengate`;

    return this.http.post<any>(url, body, { headers: headers });
  }

  public GetEngateOrDesengateById(PK_ENGT_DSGT: number): Observable<any> {
    const url = `${environment.baseURL}EngateDesengate/GetEngateOrDesengateById?PK_ENGT_DSGT=${PK_ENGT_DSGT}`;

    return this.http.get<any>(url);
  }

  public GetEngateOrDesengates(
    params: IGetEngatesOrDesengatesParams
  ): Observable<IGetEngatesOrDesengatesResponse> {
    const url = `${environment.baseURL}EngateDesengate/GetEngatesOrDesengates`;
    params.PAGE_NUMBER = params.PAGE_NUMBER || 1;

    const invalidParams = ['', null, undefined, NaN, 0];

    const validParams = Object.fromEntries(
      Object.entries(params).filter(
        ([_, value]) => !invalidParams.includes(value)
      )
    );

    return this.http.get<any>(url, { params: validParams });
  }

  public GetReceiptEngateById(
    PK_ENGT: number,
    FL_TIPO_DOCU: number
  ): Observable<IGetReceiptEngateByIdResponse> {
    const url = `${environment.baseURL}EngateDesengate/GetReceiptEngateById?PK_ENGT=${PK_ENGT}&FL_TIPO_DOCU=${FL_TIPO_DOCU}`;

    return this.http.get<any>(url);
  }

  public GetReceiptDesengateById(
    PK_DSGT: number,
    FL_TIPO_DOCU: number
  ): Observable<IGetReceiptDesengateByIdResponse> {
    const url = `${environment.baseURL}EngateDesengate/GetReceiptDesengateById?PK_DSGT=${PK_DSGT}&FL_TIPO_DOCU=${FL_TIPO_DOCU}`;

    return this.http.get<any>(url);
  }

  public VerifyComponentesByEngate(PK_GATE_ENTR: number): Observable<any> {
    const url = `${environment.baseURL}EngateDesengate/VerifyComponentesByEngate`;

    const body = { PK_GATE_ENTR: PK_GATE_ENTR };

    return this.http.put<any>(url, body);
  }

  public GetEngateDesengateInfoById(
    PK_ENGT_DSGT: number
  ): Observable<IGetEngateDesengateInfoByIdResponse> {
    const url = `${environment.baseURL}EngateDesengate/GetEngateDesengateInfoById?PK_ENGT_DSGT=${PK_ENGT_DSGT}`;

    return this.http.get<any>(url);
  }

  public GetCarretasNaoEngatadasInfoByIdOrPlacaOrAgendamento(
    params: IGetCarretasNaoEngatadasInfoByIdOrPlacaOrAgendamentoParams
  ): Observable<IGetCarretasNaoEngatadasInfoByIdOrPlacaOrAgendamentoResponse> {
    const url = `${environment.baseURL}EngateDesengate/GetCarretasNaoEngatadasInfoByIdOrPlacaOrAgendamento`;

    const invalidParams = ['', null, undefined, NaN, 0];

    const validParams = Object.fromEntries(
      Object.entries(params).filter(
        ([_, value]) => !invalidParams.includes(value)
      )
    );

    return this.http.get<any>(url, { params: validParams });
  }
}
